module.exports = require("mini-store");


//////////////////
// WEBPACK FOOTER
// external "mini-store"
// module id = 4
// module chunks = 0